export var licenseMethods;
(function (licenseMethods) {
    licenseMethods["CLOUD"] = "cloud";
    licenseMethods["ON_PREMISE"] = "on_premise";
})(licenseMethods || (licenseMethods = {}));
var UIModelProjects = /** @class */ (function () {
    function UIModelProjects(response) {
        this.projects = response.projects.map(function (project) { return new UIModelProject(project); });
        this.total = response.total;
    }
    return UIModelProjects;
}());
export { UIModelProjects };
var UIModelProject = /** @class */ (function () {
    function UIModelProject(response) {
        var _this = this;
        this.update = function (response) {
            _this.appId = response.appId;
            _this.clientId = response.clientId;
            _this.partnerId = response.partnerId;
            _this.createdAt = new Date(response.createdAt);
            _this.modifiedAt = new Date(response.modifiedAt);
            _this.inbox = response.inbox;
            _this.licenseModel = response.licenseModel;
            _this.id = response.id;
            _this.name = response.name;
            _this.status = response.status;
            _this.apiUserEmail = response.apiUserEmail;
            _this.webhook = {
                url: response.webhook.url,
            };
        };
        this.update(response);
    }
    Object.defineProperty(UIModelProject.prototype, "formValues", {
        get: function () {
            return {
                name: this.name,
                inbox: this.inbox,
                licenseModel: this.licenseModel,
                webhookUrl: this.webhook.url,
                apiUserEmail: this.apiUserEmail,
            };
        },
        enumerable: false,
        configurable: true
    });
    return UIModelProject;
}());
export { UIModelProject };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInByb2plY3QubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFOLElBQVksY0FHWDtBQUhELFdBQVksY0FBYztJQUN4QixpQ0FBZSxDQUFBO0lBQ2YsMkNBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUhXLGNBQWMsS0FBZCxjQUFjLFFBR3pCO0FBRUQ7SUFJRSx5QkFBWSxRQUFtQztRQUM3QyxJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUNuQyxVQUFDLE9BQU8sSUFBSyxPQUFBLElBQUksY0FBYyxDQUFDLE9BQU8sQ0FBQyxFQUEzQixDQUEyQixDQUN6QyxDQUFDO1FBQ0YsSUFBSSxDQUFDLEtBQUssR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDO0lBQzlCLENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUFWRCxJQVVDOztBQUVEO0lBZ0JFLHdCQUFZLFFBQWtDO1FBQTlDLGlCQUVDO1FBRUQsV0FBTSxHQUFHLFVBQUMsUUFBa0M7WUFDMUMsS0FBSSxDQUFDLEtBQUssR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDO1lBQzVCLEtBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDLFFBQVEsQ0FBQztZQUNsQyxLQUFJLENBQUMsU0FBUyxHQUFHLFFBQVEsQ0FBQyxTQUFTLENBQUM7WUFDcEMsS0FBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsU0FBUyxDQUFDLENBQUM7WUFDOUMsS0FBSSxDQUFDLFVBQVUsR0FBRyxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLENBQUM7WUFDaEQsS0FBSSxDQUFDLEtBQUssR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDO1lBQzVCLEtBQUksQ0FBQyxZQUFZLEdBQUcsUUFBUSxDQUFDLFlBQVksQ0FBQztZQUMxQyxLQUFJLENBQUMsRUFBRSxHQUFHLFFBQVEsQ0FBQyxFQUFFLENBQUM7WUFDdEIsS0FBSSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDO1lBQzFCLEtBQUksQ0FBQyxNQUFNLEdBQUcsUUFBUSxDQUFDLE1BQU0sQ0FBQztZQUM5QixLQUFJLENBQUMsWUFBWSxHQUFHLFFBQVEsQ0FBQyxZQUFZLENBQUM7WUFDMUMsS0FBSSxDQUFDLE9BQU8sR0FBRztnQkFDYixHQUFHLEVBQUUsUUFBUSxDQUFDLE9BQU8sQ0FBQyxHQUFHO2FBQzFCLENBQUM7UUFDSixDQUFDLENBQUM7UUFsQkEsSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN4QixDQUFDO0lBbUJELHNCQUFJLHNDQUFVO2FBQWQ7WUFDRSxPQUFPO2dCQUNMLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtnQkFDZixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7Z0JBQ2pCLFlBQVksRUFBRSxJQUFJLENBQUMsWUFBWTtnQkFDL0IsVUFBVSxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRztnQkFDNUIsWUFBWSxFQUFFLElBQUksQ0FBQyxZQUFZO2FBQ2hDLENBQUM7UUFDSixDQUFDOzs7T0FBQTtJQUNILHFCQUFDO0FBQUQsQ0FBQyxBQTlDRCxJQThDQyJ9